import styled from 'styled-components'
import { colors } from '../../../../constants'

export const Header = styled.div`
    display: flex;
    font-size: 15px;
    height: 20%;
    justify-content: space-between;
`

export const Body = styled.div`
  align-items: flex-end;
  margin: 0;
  padding: 0;
  width 100%;
  height: 80%;
`

export const Note = styled.div`
  font-size: 20px;
  margin: 0;
  padding: 0;
  width 100%;
  height: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const Author = styled.div`
  color: ${colors.greylight}
  font-size: 12px;
  text-align: right;
  padding-right: 5px;
  font-style: italic;
  height: 30%;
  overflow: hidden;
  text-overflow: ellipsis;
`
